import { addOrUpdateArrayItem } from "services/utils";
const reactTableDeliveries = {
  state: {
    filterValues: [],
    globalFilterValue: undefined,
    isRemovingFilters: false,
  },
  reducers: {
    addOrUpdateFilterValue: (state, newValue) => {
      const { id, value } = newValue;
      const filterItem = { id: id, value: value };
      const valuesArray = addOrUpdateArrayItem(
        state.filterValues,
        (item) => item.id === id,
        filterItem
      );
      return {
        ...state,
        filterValues: valuesArray,
      };
    },
    setGlobalFilterValue: (state, newValue) => {
      return {
        ...state,
        globalFilterValue: newValue !== "" ? newValue : undefined,
      };
    },
    setIsRemovingFilters: (state) => {
      return {
        ...state,
        isRemovingFilters: true,
      };
    },
    resetFilters: (state) => {
      return {
        ...state,
        filterValues: [],
        globalFilterValue: undefined,
        isRemovingFilters: false,
      };
    },
  },
};

export default reactTableDeliveries;
